import React from 'react';
import TimeTrackingDashboard from '../components/timetracking/TimeTrackingDashboard';

const TimeTracking = () => {
  return <TimeTrackingDashboard />;
};

export default TimeTracking;